import React, { useState  } from "react";

import { Form, Button } from "react-bootstrap";
import validator from "validator";
import api from "../../services/api";
import "../../styles/etapas.css";

function StepTwo({ nextStep, handleFormData, prevStep, values }) {
  
  
  
  
  const [error, setError] = useState(false);
  const [cepV, setCepV] = useState("");

  // after form submit validating the form data using validator
  const submitFormData = (e) => {
    e.preventDefault();

    // checking if value of first name and last name is empty show error else take to next step
    if (
      validator.isEmpty(values.logradouro) ||
      validator.isEmpty(values.numero)
    ) {
      setError(true);
    } else {
      nextStep();
    }
  };

  const handleCEP = async (e) => {
    try {
      e.preventDefault();
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await api.get(`/api/users/cep/${cepV}`, config);
      console.log(data);

      document.querySelector("[name='logradouro']").value = data.street;
      values.logradouro = data.street;

      document.querySelector("[name='cep']").value = data.cep;
      values.cep = data.cep;

      document.querySelector("[name='bairro']").value = data.neighborhood;
      values.bairro = data.neighborhood;

      document.querySelector("[name='estado']").value = data.state;
      values.estado = data.state;

      document.querySelector("[name='cidade']").value = data.city;
      values.cidade = data.city;
    } catch (error) {
      document.querySelector("[name='logradouro']").value = "";
      values.logradouro = "";

      document.querySelector("[name='cep']").value = "";
      values.cep = "";

      document.querySelector("[name='bairro']").value = "";
      values.bairro = "";

      document.querySelector("[name='estado']").value = "";
      values.estado = "";

      document.querySelector("[name='cidade']").value = "";
      values.cidade = "";
    }
  };

  return (
    <>
      <div className="container">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-lg">
                <div className="p-5">
                  <div className="text-center">


                  <h5 className="h5 text-gray-900 mb-4">
                     CADASTRO CLIENTE <br />
                     <smal style={{ fontSize: "14px" }}>
                      Trabalhador do Comércio
                      </smal>
                  </h5><br/>

                  
                  <div class="card card-timeline px-1 border-none mb-5">
                  <ul class="bs4-order-tracking">
                      <li class="step active">
                          <div><i className="fas fa-user"></i></div>  <label style={{ fontSize: "10px" }}>pessoal </label> 
                      </li>
                      <li >
                          <div><i className="far fa-envelope-open"></i></div>  <label style={{ fontSize: "10px" }}> endereço</label>
                      </li>
                      <li >
                          <div><i className="far fa-address-card"></i></div> <label style={{ fontSize: "10px" }}> profissional </label>
                      </li>
                      <li >
                          <div><i className="fas fa-file-upload"></i></div> <label style={{ fontSize: "10px" }}> documentação </label>
                      </li>
                  </ul>
                  </div>
                  
                  
                  
                  </div>

                  {/* formulario de cadastro  */}

                  <form className="user" onSubmit={submitFormData}>
                    <div className="form-group row">
                      <div className="form-group col-sm-2">
                        <label style={{ fontSize: "10px" }}>CEP</label>
                        <input
                          type="text"
                          className="form-control "
                          onChange={(e) => setCepV(e.target.value)}
                          onBlur={handleCEP}
                          name="cep"
                          defaultValue={values.cep}
                        />
                      </div>
                    </div>

                    <hr className="mt-4" />

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>LOGRADOURO</label>

                        <input
                          style={{ border: error ? "2px solid red" : "" }}
                          type="text"
                          className="form-control "
                          onChange={handleFormData("logradouro")}
                          name="logradouro"
                          defaultValue={values.logradouro}
                          disabled
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label style={{ fontSize: "10px" }}>NÚMERO</label>

                        <input
                          type="text"
                          className="form-control "
                          placeholder="Nº do imóvel"
                          style={{ border: error ? "2px solid red" : "" }}
                          onChange={handleFormData("numero")}
                          name="numero"
                          defaultValue={values.numero}
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6">
                        <label style={{ fontSize: "10px" }}>BAIRRO</label>

                        <input
                          type="text"
                          className="form-control "
                          style={{ border: error ? "2px solid red" : "" }}
                          onChange={handleFormData("bairro")}
                          name="bairro"
                          defaultValue={values.bairro}
                          disabled
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>ESTADO</label>

                        <input
                          type="text"
                          className="form-control "
                          style={{ border: error ? "2px solid red" : "" }}
                          onChange={handleFormData("estado")}
                          name="estado"
                          defaultValue={values.estado}
                          disabled
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label style={{ fontSize: "10px" }}>CIDADE</label>

                        <input
                          type="text"
                          className="form-control "
                          style={{ border: error ? "2px solid red" : "" }}
                          onChange={handleFormData("cidade")}
                          name="cidade"
                          defaultValue={values.cidade}
                          disabled
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <hr className="mt-4" />

                    <Button
                      onClick={prevStep}
                      className="btn btn-primary btn-user btn-block bg-warning"
                    >
                      Anterior
                    </Button>

                    <Button
                      type="submit"
                      className="btn btn-primary btn-user btn-block"
                    >
                      Continuar
                    </Button>
                  </form>

                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StepTwo;
